import { Subscription } from "types/Models/subscription";
import { SalesTaxFilingSubscribedState } from "./SalesTaxFilingSubscribedState";
import { SubscriptionTypeCard } from "./SubscriptionTypeCard";

export const SalesTaxFilingSubscriptionCard = ({
  subscription,
}: {
  subscription: Subscription;
}) => {
  return (
    <>
      <SubscriptionTypeCard subscription={subscription} isPrimarySubscription />
      {subscription.group_subscription?.map((subscribedState) => (
        <SalesTaxFilingSubscribedState
          key={subscribedState.group_subscription_id}
          subscribedState={subscribedState}
          amount={subscription.amount}
        />
      ))}
    </>
  );
};
